import { CompanyHighlight } from '../generated/graphql';

export function getHighlightMessage(highlight?: CompanyHighlight): string {
  if (!highlight) {
    return '';
  }

  return `${highlight.topLabel} ${highlight.centerLabel} ${highlight.bottomLabel}`.trim();
}
